import angular from 'angular';
import dndDraggableSelectionFix from './dnd-fix.directive';

let DndFixModule = angular.module('dnd-fix-module', [])
    .directive('dndDraggable', dndDraggableSelectionFix)
    .name;

export default DndFixModule;



// WEBPACK FOOTER //
// ./client/app/common/dnd-fix/index.js